import { render } from "./VideoEmbed.vue?vue&type=template&id=dbce9f30&scoped=true"
import script from "./VideoEmbed.vue?vue&type=script&lang=js"
export * from "./VideoEmbed.vue?vue&type=script&lang=js"

import "./VideoEmbed.vue?vue&type=style&index=0&id=dbce9f30&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dbce9f30"]])

export default __exports__